export const isMobile = () => {
  return document.body.offsetWidth <= 928
}

export const isDesktop = () => {
  return document.body.offsetWidth > 928
}

export const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
}

export const getDeviceOrientation = () => {
  let orientation
  if (window.orientation) {
    orientation = window.orientation === 0 ? "portrait" : "landscape"
  } else {
    const width = window.innerWidth || screen.width
    const height = window.innerHeight || screen.height
    orientation = width > height ? "landscape" : "portrait"
  }
  return orientation
}
